<div class="wrapper">
  <mat-form-field appearance="outline">
    <mat-label>Город</mat-label>
    <input
      matInput
      type="text"
      (input)="searchCities()"
      placeholder="Город"
      [formControl]="control"
    />
  </mat-form-field>

  <table mat-table [dataSource]="cities">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let city" class="cityId">{{ city.id }}</td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef>Город</th>
      <td mat-cell *matCellDef="let city" class="cityDescription">{{ city.description }}</td>
    </ng-container>
    <ng-container matColumnDef="menu">
      <th mat-header-cell *matHeaderCellDef>
        <button mat-icon-button (click)="addCity()">
          <mat-icon>add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let city">
        <button mat-icon-button color="primary" (click)="updateCity(city)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="removeCity(city)">
          <mat-icon>remove</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</div>
